
import { ContentItem, Elements } from '@kentico/kontent-delivery';
import {  resolveContentLink } from '../Utilities/ContentLinks';

/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 
 */
export class PortalPage extends ContentItem {
        constructor() {
        super({
            propertyResolver: ((elementName) => {
                if (elementName === 'page_body') {
                    return 'pageBody';
                }
                if (elementName === 'locked_selector') {
                    return 'lockedSelector';
                }
                if (elementName === 'short_description') {
                    return 'shortDescription';
                }
                if (elementName === 'publications_date') {
                    return 'publicationsDate';
                }
                if (elementName === 'page_title') {
                    return 'pageTitle';
                }
                return elementName;
            }),
            linkResolver: (link) => resolveContentLink(link)
        });
    }
}
